import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord, requirePermission } from '@/app/guards';
import { NotFoundView } from '@/features/shell';
import { PayoutRunPage, runQuery } from '@/features/staff-commission';

export const Route = createFileRoute('/_app/staff-commission/payout-runs/$runId')({
  staticData: { crumb: 'staffCommission:nav.payoutRuns', crumbTo: '/staff-commission/payout-runs' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'staff_commission.payout', 'Staff commission payout runs'),
  loader: async ({ context, params }) => {
    const run = await ensureRecord(context.queryClient.query({ ...runQuery(params.runId), staleTime: 'static' }));
    return { crumb: run.number };
  },
  notFoundComponent: function RunNotFound() {
    const { runId } = Route.useParams();
    return <NotFoundView reference={runId} />;
  },
  component: function StaffPayoutRun() {
    const { runId } = Route.useParams();
    return <PayoutRunPage runId={runId} />;
  },
});
